
    import {defineComponent} from 'vue';

    export default defineComponent({
        name: 'Cronometro-nome',
        props: {
            tempoEmSegundos: {
                type: Number,
                default: 0
            }
        },
        computed:{
            tempoDecorrido() : string {
                return new Date(this.tempoEmSegundos * 1000).toISOString().substring(11, 19)
            }
        }
    })
